// @flow
import { connect } from 'react-redux';
import Scrap from '../components/Scrap';

import type { RootState } from '../../index';
import {bindActionCreators} from "redux";
import {push} from "react-router-redux";

function mapStateToProps(state: RootState) {
  return {
    user: state.auth.user,
    authenticated: state.auth.authenticated,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ goToRedirect: (route: string) => push(route) }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Scrap);



// WEBPACK FOOTER //
// ./src/modules/scrap/containers/ScrapContainer.js